module.exports = __webpack_public_path__ + "img/9788994750002.0fc64ce4.jpg";